import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      transform="translate(4 6)"
      d="M6.33333 3.50033V0.166992L0.5 6.00033L6.33333 11.8337V8.41699C10.5 8.41699 13.4167 9.75033 15.5 12.667C14.6667 8.50033 12.1667 4.33366 6.33333 3.50033Z"
      fill={fill}
    />
  </g>
);

export default Icon;
